import { Injectable, inject } from '@angular/core';
import {Router} from '@angular/router';
import {AuthenticationService} from '../_services/authentication.service';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

@Injectable()
export class IsLoggedIn {
  private router = inject(Router);
  private authService = inject(AuthenticationService);


  resolve(): Observable<void> {
    return this.authService.isLoggedAsync().pipe(
      map((isLogged: boolean) => {
        if (isLogged) {
          this.router.navigate(['/dashboard']);
        }
      })
    );
  }
}
